import { SheetHeader } from '@/src/packages/components/ui/Sheet';

export const BasketDrawerHeader = () => {
  return <SheetHeader title="Your bag" />;
};
